// Row metadata for the grid: label + hover tooltip (+ tone for sign colouring).
// `budgeted` is the parent of the editable campaign rows; `acumulado` is derived
// on the client (running Σ real − ideal), not a payload field.
export const ROW_META = {
  revenue_goal: {
    label: 'Objetivo de venta',
    tip: 'Cuánto querés vender ese día (viene de tus objetivos diarios).',
  },
  budgeted: {
    label: 'Presupuestado',
    tip: 'Lo que planeás gastar = suma de los daily budgets de las campañas.',
  },
  should_spend: {
    label: 'Ideal',
    tip: 'Lo que deberías gastar para tu % de marketing objetivo (objetivo de venta × %mkt).',
  },
  real: { label: 'Real', tip: 'Lo que gastaste de verdad, del pipeline.' },
  delta: {
    label: 'Desvío del plan',
    tip: 'Presupuestado − Ideal. Cuánto se desvía tu plan del ideal (+ estás por encima).',
    tone: true,
  },
  real_pct: {
    label: '% mkt real',
    tip: 'Marketing % real acumulado en el mes = inversión real ÷ venta real. Compará con tu % objetivo.',
  },
};

const WEEKDAYS = ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'];
const NUMBER = new Intl.NumberFormat('es-ES', { maximumFractionDigits: 0 });

// Compact money for the grid: "$15.733", "-$5.696", "—". The currency code is
// shown once in the header, not repeated per cell.
export function formatMoneyCell(value) {
  if (value === null || value === undefined) return '—';
  const rounded = Math.round(value);
  return `${rounded < 0 ? '-' : ''}$${NUMBER.format(Math.abs(rounded))}`;
}

export function formatPct(fraction) {
  if (fraction === null || fraction === undefined) return '—';
  return `${(fraction * 100).toFixed(1).replace(/\.0$/, '')}%`;
}

export function deltaTone(value) {
  if (value === null || value === undefined) return 'neutral';
  if (value > 0) return 'positive';
  if (value < 0) return 'negative';
  return 'neutral';
}

// Parse in UTC so a 'YYYY-MM-DD' never shifts a day under a negative offset.
export function dayLabel(iso) {
  const d = new Date(`${iso}T00:00:00Z`);
  return {
    day: String(d.getUTCDate()).padStart(2, '0'),
    weekday: WEEKDAYS[d.getUTCDay()],
  };
}

export function columnTotals(days, keys) {
  const totals = {};
  for (const key of keys) {
    const values = days
      .map((d) => d[key])
      .filter((v) => v !== null && v !== undefined);
    totals[key] = values.length ? values.reduce((a, b) => a + b, 0) : null;
  }
  return totals;
}

// Running month-to-date real marketing %: Σ real spend ÷ Σ real revenue. Days
// without both real spend and real revenue render as null (no data yet).
export function cumulativeRealPct(days) {
  let spend = 0;
  let revenue = 0;
  return days.map((d) => {
    if (d.real === null || d.real === undefined || d.real_revenue === null || d.real_revenue === undefined) {
      return null;
    }
    spend += d.real;
    revenue += d.real_revenue;
    return revenue > 0 ? spend / revenue : null;
  });
}

// A day strictly before `today` (both 'YYYY-MM-DD') — its budget is history,
// so its campaign cells are read-only.
export function isPastDate(iso, today) {
  return iso < today;
}
